import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function ChatSendIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.4658 2.74155C21.4188 2.65355 21.3478 2.58155 21.2598 2.53455C19.1738 1.42455 6.69482 5.29255 3.46682 7.15455C2.62582 7.63955 2.25082 8.20955 2.35382 8.84555C2.65082 10.6876 7.61382 12.0836 10.3068 12.7086L15.3638 7.65255C15.6568 7.35955 16.1318 7.35955 16.4248 7.65255C16.7178 7.94556 16.7178 8.42055 16.4248 8.71355L11.3188 13.8176C11.9598 16.5386 13.3408 21.3536 15.1538 21.6456C15.2218 21.6566 15.2898 21.6626 15.3568 21.6626C15.9108 21.6626 16.4108 21.2826 16.8438 20.5326C18.7058 17.3076 22.5768 4.83055 21.4658 2.74155Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
